import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { createvideo, updatevideo, getvideo, deletevideos } from '../../ReduxToolkit/Slice/Video/Video';
import { ToastContainer } from "react-toastify";

function Video() {
    const dispatch = useDispatch();
    const closeButtonRef = useRef(null); // Ref to the close button
    const { status, videos } = useSelector((state) => state.video);
    const [Url, setUrl] = useState(null);
    const [thumbnail, setThumbnail] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");

    // create
    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('thumbnail', thumbnail === null ? "" : thumbnail); // Update 'video' key with 'thumbnail'
        formData.append('title', title);
        formData.append('Url', Url); // Add Url to formData
        formData.append('description', description); // Add description to formData
        dispatch(createvideo(formData));
        setThumbnail(null); // Reset thumbnail state
        setTitle(""); // Reset title state
        setUrl(""); // Reset Url state
        setDescription(""); // Reset description state
        closeButtonRef.current.click(); // Programmatically click the close button
    };
    //  get
    useEffect(() => {
        if (status === "idle") {
            dispatch(getvideo())
        }
    }, [dispatch, status]);
    // delete api
    const handleDelete = (videoid) => {
        const Isconfirmed = window.confirm("Are you sure! you want delete this Image?")
        if (Isconfirmed) {
            dispatch(deletevideos(videoid))
        };

    }
    // single data fetch
    const [updateButton, setUpdateButton] = useState("d-none");
    const [SubmitButton, setSubmitButton] = useState("");
    const [selectedId, setSelectedId] = useState(null);
    const handleId = (id) => {
        const selectedVideo = videos.data.find(video => video._id === id);
        setTitle(selectedVideo.title);
        setThumbnail(selectedVideo.thumbnail);
        setUrl(selectedVideo.Url);
        setDescription(selectedVideo.description);
        setSelectedId(id);
        if (selectedVideo) {
            setUpdateButton("");
            setSubmitButton("d-none");
        }
    };

    // update
    const handleEdit = () => {
        const formData = {
            title,
            Url,
            description
        }
        dispatch(updatevideo({ selectedId, formData }));
        setTitle(""); 
        setUrl("");
        setDescription(""); 
    }
    return (
        <>
            <div>
                <ToastContainer/>
                <div className='d-flex justify-content-between my-3'>
                    <h3>Video</h3>

                    <button className='btn btn-primary' data-bs-toggle="modal" data-bs-target="#exampleModal"><i className='bi bi-plus-circle-fill'></i> Add Video </button>
                </div>
                <div className='table-responsive'>
                    <table className="table table-hover">
                        <thead className="table-primary">
                            <tr>
                                <th scope="col">S.no</th>
                                <th scope="col">Title</th>
                                <th scope="col">Thumbnail</th>
                                <th scope="col">Link</th>
                                <th scope="col">Description</th>
                                <th scope="col">date</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {status === "loading" && (
                                <tr className='my-2'>
                                    <td colSpan={8}>
                                        <Skeleton count={10} height={90} />
                                    </td>
                                </tr>
                            )}
                            {status === "failed" && (
                                <tr>
                                    <td colSpan={8}>
                                        <p className='text-center fw-bold'>{"Data not found"}</p>
                                    </td>
                                </tr>
                            )}
                            {status === "succeeded" && videos.data && videos.data.map((videos, index) => {
                                const newdate = new Date(videos.createdAt);
                                const formattedDate = newdate.toLocaleDateString("default", {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric"
                                });
                                return (
                                    <tr key={videos._id}>
                                        <th scope="row">{index + 1}</th>
                                        <td>{videos.title}</td>
                                        <td><img src={videos.thumbnail} width={"70"} height={"70"} className='rounded-circle img-fit' alt="" /> </td>
                                        <td><a href={videos.Url} target='_blank'>Video Link</a></td>
                                        <td>{videos.description}</td>
                                        <td>{formattedDate}</td>
                                        <td className='cursor'>
                                            <div onClick={() => handleId(videos._id)}><i className='bi bi-pencil-square text-primary fs-5' data-bs-toggle="modal" data-bs-target="#exampleModal"></i></div>
                                            <div onClick={() => handleDelete(videos._id)}><i className='bi bi-trash text-danger fs-5'></i></div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal  */}
            <div
                className="modal fade"
                id="exampleModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                Upload Video
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <form action="" onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="mb-3 col-lg-12">
                                        <label htmlFor="title" className="form-label">
                                            Image Title
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            className="form-control"
                                            id="title"
                                            name="title"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            placeholder="Title"
                                        />
                                    </div>

                                    <div className={`mb-3 col-lg-12 ${SubmitButton}`}>
                                        <label htmlFor="thumbnail" className="form-label">
                                            Thumbnail
                                        </label>
                                        <input
                                            type="file"
                                            required
                                            className="form-control"
                                            id="thumbnail"
                                            name="thumbnail"
                                            onChange={(e) => setThumbnail(e.target.files[0])}
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-12">
                                        <label htmlFor="url" className="form-label">
                                            Video Url
                                        </label>
                                        <input
                                            type="text"
                                            required
                                            className="form-control"
                                            id="url"
                                            name="Url"
                                            value={Url}
                                            onChange={(e) => setUrl(e.target.value)}
                                            placeholder="Title"
                                        />
                                    </div>
                                    <div className="mb-3 col-lg-12">
                                        <label htmlFor="description" className="form-label">
                                            description
                                        </label>
                                        <textarea
                                            type="text"
                                            required
                                            className="form-control"
                                            id="description"
                                            name="description"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            placeholder="Title"
                                        />
                                    </div>
                                    <div className={`modal-footer ${SubmitButton}`}>
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                        ref={closeButtonRef}
                                    >
                                        Close
                                    </button>
                                    <button type="submit" className={`btn btn-primary`}>
                                        Upload
                                    </button>
                                </div>
                                    {/* Other input fields for Url, description, etc. */}
                                </div>
                               
                            </form>

                            <div className={`modal-footer ${updateButton}`}>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                                <button type="button" onClick={handleEdit} className={`btn btn-primary`} data-bs-dismiss="modal">
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Video;
